export default {
	_init() {
		if ( !this.options.Vue.router ) {
			return "vue-router.2.x.js : Vue.router must be set.";
		}
	},

	_bindData( data, ctx ) {
		data = data || {};

		const error = data.error;
		const success = data.success;

		data.query = ctx.$route.query || {};

		if ( data.success ) {
			data.success = function( res ) {
				success.call( ctx, res );
			};
		}
		if ( data.error ) {
			data.error = function( res ) {
				error.call( ctx, res );
			};
		}

		return data;
	},

	_beforeEach( routerBeforeEach, transitionEach ) {
		const me = this;

		this.options.Vue.router.beforeEach( function( transition, location, next ) {
			me.options.setTransitions.call( this, transition );

			routerBeforeEach.call( me, function() {
				const auth = me.options.getAuthMeta( transition );

				transitionEach.call( me, transition, auth, function( redirect ) {
					if ( !redirect ) {
						( next || transition.next )();
						return;
					}

					// router v2.x
					if ( next ) {
						next( redirect );
					} else {
						this.options.router._routerReplace.call( this, redirect );
					}
				} );
			} );
		} );
	},

	_routerReplace( data ) {
		this.options.Vue.router.replace( data );
	},

	_routerGo( data ) {
		const router = this.options.Vue.router;

		( router.push || router.go ).call( router, data );
	}
};
